import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-consent-warning-dialog',
  templateUrl: './consent-warning-dialog.component.html',
  styleUrls: ['./consent-warning-dialog.component.scss']
})
export class ConsentWarningDialogComponent {
  patients: any[];

  constructor(
    public dialogRef: MatDialogRef<ConsentWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.patients = data.patients || [];
  }

  selectPatient(patient: any): void {
    this.dialogRef.close(patient.id);
  }
}

